import { Search } from 'types/Search/form';

import { stringifySearch } from './stringify';

export enum SearchAction {
    NewSearch = 'newSearch',
    None = 'none',
}

interface GetSearchActionProps {
    current: Search;
    previous?: Search;
}

export const getSearchAction = ({
    current,
    previous,
}: GetSearchActionProps): SearchAction => {
    if (!previous) {
        return SearchAction.NewSearch;
    }
    const jsonCurrent = stringifySearch(current);
    const jsonPrevious = stringifySearch(previous);

    if (jsonCurrent !== jsonPrevious) {
        return SearchAction.NewSearch;
        // check if only page changed
    } else if (
        current.pagination.currentPage !== previous.pagination.currentPage
    ) {
        return SearchAction.NewSearch;
    }

    return SearchAction.None;
};
